import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';

const styles = theme => ({
  loadingWrapper: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
});

class LoadingWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.timeIncrementMs = 50;
    this.state = {
      isLoading: false,
      loadingTimeElapsed: 0
    };
  }

  /* 
  Props - 
  isLoading: Required, boolean. Displays loading spinner when true, children when false.
  error: Required, string/object. If error occurs, displays error in component.
  message: Optional, string. Error state will console log message if provided, otherwise logs error.
  loadingMessage: Optional, string. Displays below loading spinner.
  errorWithContents: Optional, boolean. If true, displays children after error instead of error message.
  retry: Optional, function. If provided, displays a Retry button that will call the provided function.
  */

  componentDidMount = () => {
    this.props.isLoading === true && this.handleLoading();
  };

  componentDidUpdate = prevProps => {
    if (
      this.state.isLoading === false &&
      prevProps.isLoading === false &&
      this.props.isLoading === true
    ) {
      this.handleLoading();
    }
    if (
      this.state.isLoading &&
      (this.props.isLoading === false || this.props.error)
    ) {
      this.setState({ isLoading: false, loadingTimeElapsed: 0 });
      clearInterval(this.incrementer);
    }
    if (!prevProps.error && this.props.error) {
      const message = this.props.message
        ? this.props.message 
        : typeof this.props.error === 'string'
          ? this.props.error
          : 'Error';
      console.log(message)
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.incrementer);
  };

  handleLoading = () => {
    this.setState({ isLoading: true });
    this.incrementer = setInterval(
      () =>
        this.setState({
          loadingTimeElapsed:
            this.state.loadingTimeElapsed + this.timeIncrementMs
        }),
      this.timeIncrementMs
    );
  };

  render() {
    const { classes, error, style, errorWithContents, retry, loadingMessage } = this.props;
    let errorMessage;
    if (error) {
      if (error.code === 'ECONNABORTED') {
        errorMessage = 'Error: Timeout';
      } else {
        errorMessage = error.toString();
      }
    }
    return (
      <>
        {this.state.isLoading ? (
          <div className={classes.loadingWrapper} style={style}>
            {this.state.loadingTimeElapsed > 0
              ? <Grid container>
                  <Grid container item xs={12} justifyContent='center'>
                    <CircularProgress className={classes.loadingSpinner} />
                  </Grid>
                  {loadingMessage
                    ? <Grid container item xs={12} justifyContent='center'>
                        <Typography style={{marginTop: 8}}>{loadingMessage}</Typography> 
                      </Grid>
                    : null
                  }
                </Grid>
              : null}
          </div>
        ) : error && !errorWithContents ? (
          <div className={classes.loadingWrapper} style={style}>
            <div>
              <Typography variant="subtitle2" style={{color: '#000'}}>{errorMessage}</Typography>
              {retry ? (
                <Button
                  variant="outlined"
                  onClick={() => retry()}
                  style={{ margin: '10px auto 0', display: 'block' }}
                >
                  Retry
                </Button>
              ) : null}
            </div>
          </div>
        ) : (
          this.props.children
        )}
      </>
    );
  }
}

export default withStyles(styles)(LoadingWrapper);